import { useMemo } from 'react';
import { AdminController } from '../../../../controllers';
import constant from '../../../../utils/constant';

export const useAdminProductsLogic = () => {
	const {
		isLoading: isLoadingProducts,
		data: productData,
		isFetching: isFetchingProduct,
		onLimitChange: onProductLimitChange,
		limit: productLimit,
		currentPage: currentProductPage,
		setCurrentPage: setCurrentProductPage,
		setSearchQuery: setSearchProductQuery,
	} = AdminController.useGetProducts();

	const productGridData = useMemo(() => {
		if (productData?.status === constant.Success) {
			return productData?.data?.styles || [];
		}
		return [];
	}, [productData]);

	const totalProductCounts = productData?.data?.totalCounts ?? 0;

	return {
		isLoadingProducts,
		isFetchingProduct,
		onProductLimitChange,
		productLimit,
		currentProductPage,
		setCurrentProductPage,
		setSearchProductQuery,
		productGridData,
		totalProductCounts,
	};
};

export default useAdminProductsLogic;
